import { hot } from 'react-hot-loader';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import compose from 'recompose/compose';
import {
  getMobileScreenSize,
  getMobileSidebarStatus
} from '@carvana/purchase-store';
import { withDocumentTitle } from '@carvana/purchase-helpers';
import * as AppActions from './ducks/actions';
import { getUserLoggedInStatus } from './ducks/selectors';
import { getNavigationConfig } from '../dashboard/ducks/selectors';
import App from './app';

const mapStateToProps = state => ({
  showMobileSidebar: getMobileSidebarStatus(state),
  isMobile: getMobileScreenSize(state),
  isLoggedIn: getUserLoggedInStatus(state),
  navigationConfiguration: getNavigationConfig(state)
});
const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...AppActions }, dispatch);

export default compose(
  withDocumentTitle(),
  withRouter,
  hot(module),
  connect(mapStateToProps, mapDispatchToProps)
)(App);
